'use client';

import Image from 'next/image';
import Link from 'next/link';

import { Typography } from 'lighthouse';

import { SafeImage } from '@/widgets/SafeImage';
import SectionHeading from '@/widgets/ServiceLanding/SectionHeading';
import { Slider } from '@/widgets/Slider';

import { GenerateFilePreviewUrl } from '@/utilities/GenerateFilePreviewUrl';
import { getStrapiImageUrl } from '@/utilities/strapiImageUrl';

import { SubServiceTilesProps } from './models';

export const SubServiceTiles = ({ activeItemId, contentData, isFileManagerImage = false, onSelect }: SubServiceTilesProps) => {
    return (
        <section className='w-full py-8 md:py-12'>
            {contentData.title && <SectionHeading title={contentData.title} />}
            <Slider
                spaceBetween={8}
                slidesPerView={'auto'}
                navigation={false}
                className='!relative p-1 pb-2'
                mousewheel={{
                    forceToAxis: true
                }}
                swiperSlideClassName='w-fit'
                freeMode={true}>
                {contentData.content.map((item) => {
                    if (onSelect) {
                        return (
                            <button
                                key={item.id}
                                type='button'
                                aria-current={item.id === activeItemId ? 'true' : undefined}
                                className={`group flex min-w-[10rem] items-center gap-2 rounded-lg border border-N200 bg-white p-2 text-inherit
                                shadow-elevation1 transition-all duration-300 hover:border-primary/30 md:min-w-[7.5rem] md:gap-3 md:p-3
                                md:hover:-translate-y-1 md:hover:shadow-elevation2
                                ${item.id === activeItemId ? 'border-primary ring-2 ring-primary/30' : ''}`}
                                onClick={() => onSelect(item)}>
                                <div
                                    className='relative flex h-9 w-9 flex-shrink-0 items-center justify-center overflow-hidden rounded-lg
                                        bg-gradient-to-br from-primary/10 to-sky-100 transition-colors duration-300 md:h-10 md:w-10'>
                                    {isFileManagerImage ? (
                                        <SafeImage
                                            src={
                                                GenerateFilePreviewUrl({
                                                    attachableId: String(item.id),
                                                    attachment: 'CATEGORY',
                                                    type: 'MAIN',
                                                    isPrimary: true,
                                                    sortOrder: 0
                                                }).src
                                            }
                                            fallback='/images/battery/battery-placeholder.webp'
                                            alt={item.title}
                                            width={36}
                                            height={36}
                                            className='object-contain transition-transform duration-300 md:group-hover:scale-110'
                                        />
                                    ) : (
                                        <Image
                                            src={getStrapiImageUrl(item.image.url)}
                                            alt={item.title}
                                            width={36}
                                            height={36}
                                            className='object-contain transition-transform duration-300 md:group-hover:scale-110'
                                        />
                                    )}
                                </div>
                                <Typography
                                    variant='body2'
                                    component='p'
                                    fontWeight={700}
                                    className='flex-1 text-right text-[10px] font-bold leading-4 text-blackHighEmphasis md:text-xs'>
                                    {item.title}
                                </Typography>
                            </button>
                        );
                    }

                    return (
                        <Link
                            key={item.id}
                            href={item.url}
                            className='group flex min-w-[10rem] items-center gap-2 rounded-lg border border-N200 bg-white p-2 shadow-elevation1
                                transition-all duration-300 hover:border-primary/30 md:min-w-[7.5rem] md:gap-3 md:p-3 md:hover:-translate-y-1
                                md:hover:shadow-elevation2'>
                            <div
                                className='relative flex h-9 w-9 flex-shrink-0 items-center justify-center overflow-hidden rounded-lg
                                    bg-gradient-to-br from-primary/10 to-sky-100 transition-colors duration-300 md:h-10 md:w-10'>
                                {isFileManagerImage ? (
                                    <SafeImage
                                        src={
                                            GenerateFilePreviewUrl({
                                                attachableId: String(item.id),
                                                attachment: 'CATEGORY',
                                                type: 'MAIN',
                                                isPrimary: true,
                                                sortOrder: 0
                                            }).src
                                        }
                                        fallback='/images/battery/battery-placeholder.webp'
                                        alt={item.title}
                                        width={36}
                                        height={36}
                                        className='object-contain transition-transform duration-300 md:group-hover:scale-110'
                                    />
                                ) : (
                                    <Image
                                        src={getStrapiImageUrl(item.image.url)}
                                        alt={item.title}
                                        width={36}
                                        height={36}
                                        className='object-contain transition-transform duration-300 md:group-hover:scale-110'
                                    />
                                )}
                            </div>
                            <Typography
                                variant='body2'
                                component='p'
                                fontWeight={700}
                                className='flex-1 text-right text-[10px] font-bold leading-4 text-blackHighEmphasis md:text-xs'>
                                {item.title}
                            </Typography>
                        </Link>
                    );
                })}
            </Slider>
        </section>
    );
};
